module.exports = __webpack_public_path__ + "img/Group 11.e929e5df.svg";